import { Type } from "@sinclair/typebox";
import { Nullable } from "../../utils/typeboxTypes";
export const DevicePushFcmConfigSchema = Type.Object({
    fcm_token: Type.String(),
});
export const DevicePushApnConfigSchema = Type.Object({
    apn_token: Type.String(),
});
export const DevicePushWebPushConfigSchema = Type.Object({
    endpoint: Type.Optional(Type.String()),
    expirationTime: Type.Optional(Type.Union([Type.Null(), Type.Number()])),
    keys: Type.Optional(Type.Record(Type.String(), Type.String())),
});
export const DeviceChannelConfigSchema = Type.Union([
    DevicePushFcmConfigSchema,
    DevicePushApnConfigSchema,
    DevicePushWebPushConfigSchema,
]);
export const MsgrDeviceChannelSchema = Type.Object({
    id: Type.Number(),
    device_id: Type.Number(),
    notification_channel_id: Type.Number(),
    config: DeviceChannelConfigSchema,
    created_at: Nullable(Type.Date({ default: () => new Date() })),
    updated_at: Nullable(Type.Date({ default: () => new Date() })),
});
// 1	id	bigint(20)	NULL	NULL	NO	NULL	auto_increment
// 2	device_id	bigint(20)	NULL	NULL	YES	NULL		msgr_devices(id)
// 3	notification_channel_id	bigint(20)	NULL	NULL	YES	NULL		msgr_notification_channels(id)
// 4	config	json	NULL	NULL	YES	NULL
// 5	created_at	datetime	NULL	NULL	YES	NULL
// 6	updated_at	datetime	NULL	NULL	YES	NULL
